import React from 'react';
import styled from 'styled-components';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import $breakImg from '../Resources/AboutSep.jpg'

import ProjectList from '../Resources/Projectlist';



const Container = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-direction: ${props => props.$mobile ? "column" : "row"};
    position: relative;
    width: ${props => props.$mobile ? "90vw" : "100%"};
    right:  ${props => props.$mobile ? "5vw" : ""};
    margin: auto;
    overflow: visible;
    `

const CarouselBox = styled.div`
    width: 100vw;
    margin: auto;
    padding: 10px 5px;
`

const BreakImg = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    
    width: ${props => props.$mobile ? "95vw" : "80vw"};
    height: 15vh;
    background-image: url("${props => props.img}");
    border-bottom: solid 10px purple;
    background-position: center;
    background-size: cover;
    margin-top: 5vh;
    margin-bottom: 2vh;
    & h3{
    margin: 0;
    }
`
const BgC = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: rgba(100, 0, 194, 0.2);
    border: solid 10px white;
    color: white;
`
const DeskProjects = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 86%;
    min-height: 20vh;

`
const DCCont = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    width: ${props => props.$mobile ? "95%" : "22vw"};
    height: ${props => props.$mobile ? "75vw" : "19vw"};
    margin: ${props => props.$mobile ? "15px auto 0 auto" : "10px 10px;"}; 
    overflow: visible ;

    & div:first-child{
        position: relative;
        transform: rotate(-10deg);
        left: 8%;
    };
    & div:nth-child(2){
        transform: rotate(10deg);
        right: 10%;
        top: 15px;
    };

    $ :hover{
        scale: 1.2
    }
`
const DImg = styled.div`
    position: relative;
    width: ${props => props.$mobile ? "80vw" : "20vw"};
    height: ${props => props.$mobile ? "60vw" : "15vw"};
    border: solid 3px white;
    background-image: url("${props => props.$img}");
    background-size: cover;
    background-position: center;
    border-radius: 2px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`
const DTxt = styled.div`
    position: absolute ;
    width: 100%;
    min-height: 15px;
    bottom: 0px;
    background: white;
    font-weight: bold;
`
function Projects(props) {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 40
        }
    };
    const set = props.setProj
    function ProjClick(i, item, props) {
        set(i)
    }
    return (
        <>
            <Container>
                <BreakImg $mobile={props.$mobile} img={$breakImg}>
                    <BgC>
                        <h1>Projects</h1>
                    </BgC>
                </BreakImg>
            </Container>

            <Container $mobile={props.$mobile} id="ProjectsContainer" >

                {props.$mobile ?
                    <CarouselBox>
                        < Carousel responsive={responsive} showDots={true} infinite={true} renderDotsOutside={true}>
                            {ProjectList.map((item, i) => {
                                return (
                                    <DCCont key={i} $mobile={props.$mobile} onClick={() => ProjClick(i, item, props)}>
                                        {item.images.map((img, i) => {
                                            return (
                                                <DImg $mobile={props.$mobile} key={i} $img={img}></DImg>
                                            )
                                        })}
                                        <DTxt>{item.name}</DTxt>
                                    </DCCont>
                                )
                            })}
                        </Carousel>
                    </CarouselBox>
                    :
                    <DeskProjects>
                        {ProjectList.map((item, i) => {
                            return (
                                <DCCont key={i} $mobile={props.$mobile} onClick={() => ProjClick(i, item)}>
                                    {item.images.map((img, i) => {
                                        return (
                                            <DImg key={i} $img={img}></DImg>
                                        )
                                    })}
                                    <DTxt>{item.name}</DTxt>
                                </DCCont>
                            )
                        })}
                    </DeskProjects>
                }
            </Container >
        </>
    )
}

export default Projects;

/**
 
{projectList.map((i,) =>
                <ProjectContainer>
                    <h1>{i.title}</h1>
                    <ProjectImg imageUrl={i.pics[0].src}/>
                    <div>{i.desc}</div>
                </ProjectContainer>
            )}

 **/